import { render, staticRenderFns } from "./eligibility.vue?vue&type=template&id=2af6e9b8&scoped=true&"
import script from "./eligibility.vue?vue&type=script&lang=js&"
export * from "./eligibility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af6e9b8",
  null
  
)

export default component.exports